<div class="sidenav-shadow w-100 d-flex vh-100">
  <app-studiosite-nav [darkMode]="darkMode"></app-studiosite-nav>
  <div
    class="sidenav-menu vh-100 d-flex flex-column"
    [ngClass]="{
      'dark-mode': darkMode,
      'light-mode': !darkMode,
      closed: !isOpen,
    }"
  >
    @if (!isOpen) {
      <button
        mat-icon-button
        class="d-flex align-items-center position-absolute toggle-menu-button ignore-grid-outside-click"
        [ngClass]="darkMode ? 'dark-mode' : 'light-mode'"
        (click)="openMenu()"
      >
        <mat-icon class="menu-mat-icon">navigate_next</mat-icon>
      </button>
    }

    @if (isOpen) {
      <button
        mat-icon-button
        class="d-flex align-items-center position-absolute toggle-menu-button ignore-grid-outside-click"
        [ngClass]="darkMode ? 'dark-mode' : 'light-mode'"
        (click)="closeMenu()"
      >
        <mat-icon class="menu-mat-icon">chevron_left</mat-icon>
      </button>
    }
    @if (user) {
      @if ((activeStudiosite$ | async)?.miniVersion) {
        <div
          class="mini-version-bar bg-primary fs-11 lh-13 fw-medium d-flex align-items-center justify-content-center"
          [class.short-bar]="!isOpen"
        >
          @if (isOpen) {
            <label class="color-white">{{ "SIDENAV.MINI_TITLE_STUDIO" | translate }}</label>
          }
          @if (isOpen) {
            <label class="color-white opacity-60">{{ "SIDENAV.MINI_TITLE_CONSOLE" | translate }}</label>
          }
          <label class="color-white">{{ "SIDENAV.MINI_TITLE_MINI" | translate }}</label>
        </div>
      }
      @if ((activeStudiosite$ | async)?.miniVersion) {
        <div
          class="mini-version-bg"
          [class.short-bar]="!isOpen"
        ></div>
      }
      @if (isOpen) {
        <div
          class="channel-title d-flex align-items-start flex-column"
          [class.mt-4]="(activeStudiosite$ | async)?.miniVersion"
        >
          @if (isOnHomePage) {
            <h2
              class="mb-0 fs-20 fw-black"
              [class.white-title]="darkMode"
            >
              {{ user.fullName }}
            </h2>
            <span class="fs-14 color-secondary">
              {{ user.defaultRole }}{{ !!user.company && !!user.defaultRole ? ", " : null }}{{ user.company }}
            </span>
          }
          @if (!isOnHomePage) {
            <h2
              class="mb-0 fs-20 fw-black"
              [class.white-title]="darkMode"
            >
              {{ (activeStudiosite$ | async)?.studioSiteName }}
            </h2>
            <span class="fs-14 color-secondary">
              {{ getUserNameAndRole(user) }}
            </span>
          }
        </div>
      }
      <mat-list
        class="sidenav-menu-links d-flex flex-column py-0 pr-3 h-100"
        [class.open]="isOpen"
      >
        @for (item of fixedNavItems; track item; let first = $first) {
          @if (isShow(item, (activeStudiosite$ | async)?.studioSiteId)) {
            @if (
              (item.featureToggleName && featureToggles.isEnabled(item.featureToggleName)) || !item.featureToggleName
            ) {
              <app-menu-list-item
                [item]="item"
                [user]="user"
                [first]="first"
                [isOpen]="isOpen"
                [darkMode]="darkMode"
                [isAr]="isArUser && !isOnHomePage"
              ></app-menu-list-item>
            }
          }
        }
      </mat-list>
      <mat-list
        class="support-link py-0 pr-3"
        [class.support-link-dark-mode]="darkMode"
      >
        <app-menu-list-item
          [item]="supportNavItem"
          [isOpen]="isOpen"
          [darkMode]="darkMode"
        ></app-menu-list-item>
      </mat-list>
      <div
        class="d-flex download-app pointer"
        [ngClass]="{
          'download-app-width': isOpen,
          'width-fit-content': !isOpen,
          'download-app-dark-mode': darkMode,
        }"
        (click)="openDownloadAppModal()"
      >
        <img
          class="icon-size-32 download-app-icon"
          src="./assets/icons/download-app-icon.png"
          alt="Download app icon"
        />
        @if (isOpen) {
          <div class="download-app-info lh-14">
            <div class="fs-11 fw-bold">{{ "SIDENAV.DOWNLOAD_APP_TITLE" | translate }}</div>
            <div class="fs-10">{{ "SIDENAV.DOWNLOAD_APP_MESSAGE" | translate }}</div>
          </div>
        }
      </div>
      <div
        class="d-flex justify-content-between user-block w-100"
        [ngClass]="{
          'flex-column': !isOpen,
          'align-items-center': isOpen,
        }"
      >
        <app-user-photo
          class="user-photo overflow-hidden"
          [user]="user"
        ></app-user-photo>
        @if (isOpen) {
          <div class="ml-2">
            <div
              class="fw-semi-bold fs-16 text-overflow-ellipsis"
              [class.white-title]="darkMode"
              [matMenuTriggerFor]="menu"
            >
              {{ user.name }}
            </div>
            <div
              class="fs-11 color-secondary text-overflow-ellipsis"
              [matTooltip]="user.email || ''"
            >
              {{ user.email || "" }}
            </div>
          </div>
        }
        @if (isOpen) {
          <button
            mat-icon-button
            [class.white-title]="darkMode"
            class="logout-btn"
            (click)="onLogout()"
          >
            <mat-icon>logout</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</div>

<mat-menu
  #menu="matMenu"
  class="p-2"
>
  <div class="version-info">
    <b>v{{ version }} ({{ versionBuild }})</b>
  </div>
  <span class="version-info">{{ "SHARED_MODULE.SESSION_STARTED" | translate }} {{ tokenExpire | date: "medium" }}</span>
</mat-menu>
